import React from "react"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"

// TODO: Ensure the classes are scoped to this component
const SupportedBrowsers = () => {
  const { t } = useTranslation()

  return (
    <>
      <div className="support-article__supported-browser">
        <img
          className="support-article__supported-browser-icon"
          src="/icons/chrome-icon.png"
          alt=""
          role="presentation"
        />
        <a className="text-link" href="https://chrome.google.com">
          Google Chrome ({t("common.latest-version")})
        </a>
      </div>
      <div className="support-article__supported-browser">
        <img
          className="support-article__supported-browser-icon"
          src="/icons/firefox-icon.png"
          alt=""
          role="presentation"
        />
        <a className="text-link" href="http://firefox.com">
          Firefox ({t("common.latest-version")})
        </a>
      </div>
      <div className="support-article__supported-browser">
        <img
          className="support-article__supported-browser-icon"
          src="/icons/edge-icon.png"
          alt=""
          role="presentation"
        />
        <a className="text-link" href="http://microsoft.com/edge">
          Microsoft Edge ({t("common.latest-version")})
        </a>
      </div>
      <div className="support-article__supported-browser">
        <img
          className="support-article__supported-browser-icon"
          src="/icons/safari-icon.png"
          alt=""
          role="presentation"
        />
        <a className="text-link" href="https://www.apple.com/safari/">
          Safari (16+)
        </a>
      </div>
    </>
  )
}

export default SupportedBrowsers
